import { useQuery } from "@tanstack/react-query";
import { apiGet } from "./client";

/** Every asset industry, alphabetical: the ONE list behind every Asset Industry filter on the Portfolio Performance pages.
 *  The server makes it from the distinct `industry` values of athena_input.asset_industry_segments, so each page adds its own
 *  "All ..." option in front of it. Empty until it loads. */
export function useAssetIndustries() {
  return useQuery({
    queryKey: ["asset-industries"] as const,
    queryFn: () => apiGet<string[]>("/asset-industries"),
    staleTime: 10 * 60_000,
  });
}
